var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2.5V1M18.4393 3.56066L19.5 2.5M19.5103 7.5H21.0103M20.9506 12C20.4489 17.0533 16.1853 21 11 21C5.47715 21 1 16.5228 1 11C1 5.81465 4.94668 1.5511 10 1.04938M11 7H15V11M14.6197 7C12.2653 10.3276 8.38636 12.5 4 12.5C2.9971 12.5 2.02072 12.3864 1.08302 12.1715",
    stroke: "#60B627",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentIcon);
export default __webpack_public_path__ + "static/media/sentiment-icon.81e85a35d381bc135151482fb1df1c52.svg";
export { ForwardRef as ReactComponent };